module.exports = __webpack_public_path__ + "img/BNB.4def8dd2.svg";